/* Copyright (c) 2017 Backpack Health LLC */

import React from 'react';

const Small = ({ color, fillClassName, strokeClassName }) => (
  <svg height="16" width="16" viewBox="0 0 16 16">
    <path className={fillClassName} style={{ fill: color }} d="M7.94,2A2.49,2.49,0,1,1,5.45,4.48,2.5,2.5,0,0,1,7.94,2m0-1.25a3.74,3.74,0,1,0,3.74,3.74A3.74,3.74,0,0,0,7.94.74Z"/>
    <path className={strokeClassName} style={{ fill: 'none', strokeLinejoin: 'round', stroke: color }} d="M5.56,9.3a5.6,5.6,0,0,0,4.72,0,.65.65,0,0,1,.51,0,4.86,4.86,0,0,1,3,3.42,9.41,9.41,0,0,1-5.85,2,9.12,9.12,0,0,1-5.85-2A4.29,4.29,0,0,1,5,9.28.67.67,0,0,1,5.56,9.3Z"/>
  </svg>
);

const Medium = ({ color }) => (
  <svg height="24" width="24" viewBox="0 0 24 24">
    <path style={{ fill: color }} d="M12,3.23A3.85,3.85,0,1,1,8.16,7.07,3.84,3.84,0,0,1,12,3.23m0-1.5a5.35,5.35,0,1,0,5.34,5.34A5.34,5.34,0,0,0,12,1.73Z"/>
    <path style={{ fill: 'none', strokeLinejoin: 'round', stroke: color }} d="M8.6,14a7.93,7.93,0,0,0,6.74.07,1,1,0,0,1,.74,0,6.92,6.92,0,0,1,4.27,4.89A13.43,13.43,0,0,1,12,21.73s-4.9.21-8.35-2.88c0,0,.13-3.22,4.14-4.93A1,1,0,0,1,8.6,14Z"/>
  </svg>
);

const Large = ({ color }) => (
  <svg height="36" width="36" viewBox="0 0 36 36">
    <path style={{ fill: color }} d="M18.18,4.38a6,6,0,1,1-6,6,6,6,0,0,1,6-6m0-2a8,8,0,1,0,8,8,8,8,0,0,0-8-8Z"/>
    <path style={{ fill: 'none', strokeLinejoin: 'round', stroke: color }} d="M13.08,20.71a11.9,11.9,0,0,0,10.1.1,1.5,1.5,0,0,1,1.12-.06,10.41,10.41,0,0,1,6.4,7.34,20.16,20.16,0,0,1-12.52,4.28s-7.35.32-12.53-4.31c0,0,.2-4.84,6.21-7.39A1.45,1.45,0,0,1,13.08,20.71Z"/>
  </svg>
);

const XLarge = ({ color }) => (
  <svg height="56" width="56" viewBox="0 0 56 56">
    <path style={{ fill: color }} d="M27.86,6.75a9.54,9.54,0,1,1-9.54,9.54,9.55,9.55,0,0,1,9.54-9.54m0-2.75A12.29,12.29,0,1,0,40.15,16.29,12.29,12.29,0,0,0,27.86,4Z"/>
    <path style={{ fill: 'none', strokeLinejoin: 'round', stroke: color }} d="M20,32.11a18.29,18.29,0,0,0,15.5.15,2.28,2.28,0,0,1,1.7-.09,16,16,0,0,1,9.83,11.26A31,31,0,0,1,27.86,50s-11.26.48-19.21-6.61c0,0,.31-7.42,9.53-11.34A2.24,2.24,0,0,1,20,32.11Z"/>
  </svg>
);

export default {
  Small,
  Medium,
  Large,
  XLarge,
};
